import { render, staticRenderFns } from "./Modals.vue?vue&type=template&id=824c7288&scoped=true"
import script from "./Modals.vue?vue&type=script&lang=js"
export * from "./Modals.vue?vue&type=script&lang=js"
import style0 from "./Modals.vue?vue&type=style&index=0&id=824c7288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824c7288",
  null
  
)

export default component.exports